import { Form } from "react-bootstrap";

const DEFAULT_OPTS = ["Ausente", "Fin de contrato", "Mala práctica", "Otro"];

export default function ReasonPicker({
                                         value,                   // { type: string, text: string }
                                         onChange,                // (next) => void
                                         options = DEFAULT_OPTS,
                                         label = "Seleccione motivo",
                                         textareaLabel = "Explique la razón",
                                         className = "",
                                     }) {
    const type = value?.type ?? "";
    const text = value?.text ?? "";

    const needsText = type === "Mala práctica" || type === "Otro";

    return (
        <div className={className}>
            <Form.Group className="mb-3">
                <Form.Label>{label}</Form.Label>
                <Form.Select
                    value={type}
                    onChange={(e) => onChange({ type: e.target.value, text })}
                >
                    <option value="">-- elige uno --</option>
                    {options.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                    ))}
                </Form.Select>
            </Form.Group>

            {needsText && (
                <Form.Group className="mb-3">
                    <Form.Label>{textareaLabel}</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={text}
                        onChange={(e) => onChange({ type, text: e.target.value })}
                    />
                </Form.Group>
            )}
        </div>
    );
}
